import { reactive } from 'vue'

export default reactive({
  users: {},
  limbo: {},
  restrictions: [],
  messages: [],

  get currentAuction () {
    return Object.values(Alpine.store('auctions').data).reduce((latest, auction) => {
      const auctionTime = new Date(auction.ends_at).getTime()

      if (!latest) return auction
      return auctionTime > new Date(latest.ends_at).getTime() ? auction : latest
    }, null)
  },

  setMessages(messages, authUserId) {
    this.messages = messages.map((message) => {
      return this.transformMessage(message, authUserId)
    })
  },

  getMessages() {
    return this.messages
  },

  addMessage(message, authUserId) {
    this.messages.push(this.transformMessage(message, authUserId))
  },

  removeMessage(messageId) {
    this.messages = this.messages.filter(message => message.id !== messageId)
  },

  transformMessage(message, authUserId) {
    return {
      ...message,
      sent_by_auth_user: message.participant.id === authUserId,
    }
  },

  setRestrictions(restrictions) {
    this.restrictions = restrictions
  },

  getRestrictions() {
    return this.restrictions
  },

  addRestriction(userId) {
    this.restrictions[userId] = true
  },

  setUser(user) {
    this.users[user.id] = user
  },

  here(users) {
    this.users = {}
    users.forEach((user) => this.setUser(user))
  },

  joining(user) {
    this.setUser(user)

    // User is back, so we'll remove them from limbo.
    if (this.limbo[user.id]) {
      clearTimeout(this.limbo[user.id])
      delete this.limbo[user.id]
    }
  },

  removeUser(user) {
    if (this.users[user.id]) {
      delete this.users[user.id]
    }
  },

  leaving(user) {
    // Page loads cause the user to leave and rejoin channels which causes
    // their status to flicker, so we'll throw the user into limbo for 5
    // seconds and if they haven't returned by then, we'll remove them.
    this.limbo[user.id] = setTimeout(() => {
      this.removeUser(user)
      delete this.limbo[user.id]
    }, 5000)
  },

  count() {
    return Object.keys(this.users).length
  },

  userIsOnline(userId) {
    return this.users[userId] !== undefined
  },
})
